(ns ui.wallet.i18n.it
  "Italian dictionary of the wallet page (see `ui.wallet.i18n`).")

(def dictionary
  {:page/loading "caricamento..."
   :page/command-failed "Qualcosa è andato storto. Riprova o scrivici in chat se il problema persiste."

   :balance/total-available "Saldo disponibile"
   :balance/pay-as-you-go "Saldo a consumo"
   :balance/used-up "Aggiungi credito per continuare a pubblicare."
   :balance/view-usage "Vedi consumi"

   :payment/title "Pagamento"
   :payment/method "Metodo di pagamento"
   :payment/billing-email "E-mail di fatturazione"
   :payment/reference "Riferimento"
   :payment/update "Modifica metodo di pagamento"
   :payment/card [:fn/str "Carta ({{:last4}})"]
   :payment/wire-transfer "Bonifico bancario"

   :billing-email/change "Modifica"
   :billing-email/new "Nuova email di fatturazione"
   :billing-email/save "Salva"
   :billing-email/saving "Salvataggio..."
   :billing-email/cancel "Annulla"
   :billing-email/hint "Paddle, il nostro rivenditore, invia ricevute e fatture a questo indirizzo."
   :billing-email/shared-hint "Se più delle tue organizzazioni condividono questo account di fatturazione, la modifica vale per tutte."
   :billing-email/invalid "Inserisci un indirizzo email valido."
   :billing-email/taken "Questo indirizzo email è già usato da un altro account di fatturazione. Usa un altro indirizzo o scrivici in chat."

   :customer-conflict/title "La tua email è già collegata a un altro account"
   :customer-conflict/text "Il tuo indirizzo email appartiene già all'account di fatturazione di un'altra organizzazione Storrito, e il nostro fornitore di pagamenti Paddle consente un solo account di fatturazione per email. Scrivici in chat e risolviamo noi."
   :customer-conflict/chat "Apri la chat di supporto"
   :customer-conflict/support-message "Ciao, non riesco ad aprire il pagamento: il mio indirizzo email appartiene già a un altro account di fatturazione."

   :top-up/title "Ricarica automatica"
   :top-up/custom-amount "Importo personalizzato"
   :top-up/opening-checkout "Apertura del pagamento..."
   :top-up/amount-missing "Inserisci un importo."
   :top-up/amount-too-small [:fn/str "Il minimo è ${{:minimum}}."]
   :top-up/amount-too-large [:fn/str "Il massimo è ${{:maximum}} per ricarica. Per importi maggiori scrivici in chat."]
   :top-up/per-month [:fn/str "${{:quantity}} ogni mese"]
   :top-up/per-year [:fn/str "${{:quantity}} ogni anno"]
   :top-up/stops-on [:fn/str "Termina il {{:date}}"]
   :top-up/next-on [:fn/str "Prossima ricarica il {{:date}}"]
   :top-up/status-cancellation-scheduled "annullamento programmato"
   :top-up/status-payment-failed "pagamento non riuscito"
   :top-up/status-active "attiva"
   :top-up/past-due "L'ultima ricarica non è stata addebitata. "
   :top-up/update-payment-method "Aggiorna il tuo metodo di pagamento"
   :top-up/resume "Riprendi la ricarica automatica"
   :top-up/cancel "Annulla la ricarica automatica"
   :top-up/paddle-unavailable "Non siamo riusciti a caricare i dettagli della tua ricarica automatica da Paddle. Riprova tra un momento."
   :top-up/try-again "Riprova"

   :plan/title-monthly "Ricarica mensile"
   :plan/title-yearly "Ricarica annuale"
   :plan/switch "Passa al pagamento a consumo"
   :plan/switching "Passaggio in corso..."
   :plan/switch-confirm [:fn/str "La tua ricarica ricorrente di ${{:quantity}} termina ora; il passaggio è gratuito. Il tuo saldo e il tuo metodo di pagamento restano. Da quel momento paghi solo quando aggiungi crediti, oppure automaticamente con la ricarica automatica."]
   :plan/wont-cover [:fn/str "Il tuo saldo probabilmente non coprirà i tuoi account Instagram collegati fino alla prossima ricarica il {{:date}}; le storie non vengono più pubblicate a $0."]
   :plan/wont-cover-advice "Attiva qui sotto la ricarica automatica oppure aggiungi crediti ora."

   :on-demand/add-credits "Aggiungi credito"
   :on-demand/choose-amount "Scegli un importo. Paghi solo ciò che usi."
   :on-demand/auto-top-up "Ricarica automatica"
   :on-demand/rule [:fn/str "Quando il tuo saldo scende sotto ${{:threshold}}, aggiungiamo ${{:amount}} automaticamente."]
   :on-demand/auto-top-up-hint "Facoltativo. Le tue storie continuano a essere pubblicate quando il credito si esaurisce; puoi disattivarlo in qualsiasi momento."
   :on-demand/add [:fn/str "Aggiungi ${{:amount}}"]
   :on-demand/charged-once "Addebitato una sola volta ora tramite Paddle, il nostro rivenditore. La tua carta viene salvata per le prossime ricariche, niente di ricorrente. Il credito non è rimborsabile. Prezzi IVA esclusa."
   :on-demand/discount-off [:fn/str "{{:percent}}% di sconto su"]
   :on-demand/discount-applied "Applicato alla tua tariffa giornaliera dalla prima ricarica, non all'importo che ricarichi. Il credito di benvenuto viene addebitato alla tariffa normale."
   :on-demand/charged-to-card "Addebitato sul tuo metodo di pagamento salvato, disponibile in pochi secondi."
   :on-demand/confirm-charge [:fn/str "Ti verranno addebitati ora ${{:amount}} USD tasse escluse."]
   :on-demand/charging "Addebito in corso..."
   :on-demand/add-now [:fn/str "Aggiungi ${{:amount}} ora"]
   :on-demand/payment-accepted "Pagamento accettato, il tuo saldo si aggiorna in pochi secondi."
   :on-demand/prices-excl-vat "Prezzi IVA esclusa."
   :on-demand/amount-too-large [:fn/str "Il massimo è ${{:maximum}} per ricarica."]
   :on-demand/on "Attiva"
   :on-demand/off "Disattivata"
   :on-demand/saving "Salvataggio..."
   :on-demand/save "Salva"
   :on-demand/custom-auto-top-up-amount "Importo personalizzato della ricarica automatica"
   :on-demand/one-charge-per-day "Al massimo un addebito automatico al giorno, sul tuo metodo di pagamento salvato, più le tasse applicabili."
   :on-demand/remove-payment-method "Rimuovi metodo di pagamento"

   :transactions/title "Transazioni recenti"
   :transactions/full-statement "Estratto completo"
   :transactions/invoices "Fatture"
   :transactions/date "Data"
   :transactions/description "Descrizione"
   :transactions/amount "Importo"
   :transactions/error "Impossibile caricare le transazioni."
   :transactions/empty "Nessun acquisto questo mese, per ora."
   :transactions/welcome-credits "Credito di benvenuto"
   :transactions/recurring-top-up "Ricarica ricorrente"
   :transactions/added-credits "Credito aggiunto"
   :transactions/refund "Rimborso del credito"

   :credit-notes/view "Note di credito"
   :credit-notes/title "Note di credito"
   :credit-notes/intro "Note di credito per i tuoi rimborsi e crediti. Le emette Paddle, il nostro rivenditore."
   :credit-notes/refund "Rimborso"
   :credit-notes/credit "Credito"
   :credit-notes/download "Scarica PDF"
   :credit-notes/empty "Ancora nessuna nota di credito."
   :credit-notes/error "Non è stato possibile caricare le note di credito."

   :offer/applied-automatically "Applicato automaticamente quando aggiungi crediti. Fino ad allora il credito di benvenuto viene addebitato alla tariffa normale."

   :rates/view "Vedi le nostre tariffe"
   :rates/title "Le nostre tariffe in breve"
   :rates/intro "Qui trovi cosa addebitiamo per ogni servizio. "
   :rates/intro-bold "Tutti i prezzi sono in dollari USA, tasse escluse (IVA esclusa)."
   :rates/per-day "al giorno"
   :rates/per-post "per post"
   :rates/per-image "per immagine"
   :rates/per-days [:fn/str "per {{:days}} giorni"]
   :rates/excl-vat "Tutti i prezzi IVA esclusa"
   :rates/off [:fn/str "-{{:percent}}%"]

   :service.storage-flat-fee/name "Canone fisso di archiviazione"
   :service.storage-flat-fee/description "per tutte le tue immagini, video, ecc."
   :service.instagram-connection/name "Collegamento account Instagram"
   :service.instagram-connection/description "Storie e Reels illimitati per un nome utente Instagram."
   :service.tiktok-post/name "Post su TikTok"
   :service.tiktok-post/description "Pubblica un video o un'immagine su TikTok."
   :service.youtube-short/name "YouTube Short"
   :service.youtube-short/description "Pubblica un video renderizzato come YouTube Short."
   :service.social-post/name "Post social"
   :service.social-post/description "Pubblica un video renderizzato o un'immagine su Facebook, Threads e altre piattaforme collegate (X viene addebitato a parte)."
   :service.x-post/name "Post su X"
   :service.x-post/description "Pubblica un video renderizzato su X. X addebita ogni post pubblicato tramite la sua API, per questo i post su X costano più degli altri post social."
   :service.x-post-link/name "Post su X con link"
   :service.x-post-link/description "Un post su X il cui testo contiene un link. X addebita molto di più per i post con link."
   :service.ai-image/name "Immagine IA"
   :service.ai-image/description "Generazione di un'immagine con l'IA (Dall-e / Blackforest)."})
